// tslint:disable:deprecation
import { overrideTabStyles, Styles } from '../styles/TabStyles';
import { ClickBustingConfig } from './ClickBusting';

interface SharedWidgetsConfig {
  /**
   * This overrides the default styling of Shared Widgets
   */
  styles?: Styles;

  /**
   * VizClient uses a technique called "click busting" (see ClickBuster.cs) to improve perceived responsiveness
   * of taps on iOS. This has some fundamental incompatibilities with React's reimplemented event system. Setting
   * this class name will allow incompatible Widgets to mark themselves as such.
   */
  suppressClickBustingClassName?: string;
}

const setTabStyles = (config: SharedWidgetsConfig): void => {
  if (!config.styles) { return; }

  overrideTabStyles(config.styles);
};

const setClickBusting = (config: SharedWidgetsConfig): void => {
  if (!config.suppressClickBustingClassName) { return; }

  ClickBustingConfig.suppressionClassName = config.suppressClickBustingClassName;
};

const setConfig = (config: SharedWidgetsConfig): void => {
  setTabStyles(config);
  setClickBusting(config);
};

export {
  Styles,
  SharedWidgetsConfig,
  setConfig
};
